export const CATEGORY_REQUEST = "CATEGORY_REQUEST";
export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS";
export const CATEGORY_FAILURE = "CATEGORY_FAILURE";



export const SET_CATEGORIES = "SET_CATEGORIES";
export const HAS_CHILD = "HAS_CHILD";
export const GET_CHILDREN = "GET_CHILDREN";



export const setCategories = (categories) => ({
    type : SET_CATEGORIES,
    categories : categories
});
export const hasChild = (categories) => ({
    type : HAS_CHILD,
    categories : categories
});
export const getChildren = (categories) => ({
    type : GET_CHILDREN,
    categories : categories
});


// WEBPACK FOOTER //
// ./src/redux/actions/categories.js